module.exports = __webpack_public_path__ + "static/media/108c4.92cb684b.jpg";